import { makeStyles, darken } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  pageRoot: {
    margin: 10,
  },
  title: {
    color: darken(theme.palette.amano.main, 0.2),
  },
  titleDivider: {
    marginBottom: 10,
    marginTop: 4,
  },
  root: {
    padding: theme.spacing(3),
    backgroundColor: "#fff",
    borderRadius: theme.shape.borderRadius,
  },
  section: {
    marginBottom: 0,
  },
  field: {
    marginBottom: theme.spacing(1),
  },
}));
